import React, {Suspense, lazy} from 'react';
import {ROUTE_WALLET_BALANCE} from '../../RoutePathConstant';
import {authLoader} from '../../loader';
import {Spin} from 'antd';

const WalletBalance = lazy( () =>
  import('../../../screens/WalletBalance').then(module => ({default: module.WalletBalance})),
);

const WalletBalanceNavigation =[
  {
    path: ROUTE_WALLET_BALANCE,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <WalletBalance />
      </Suspense>
    ),
  },
];

export default WalletBalanceNavigation;
